/**
 * @generated SignedSource<<8870fae31350a6e6a6d9f2c5c807597f>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type Permission = "AccountPermission_AZAVAdmin_IsAZAVAccount" | "AccountPermission_AccountMemberManagement_CanInviteOrAddUsersToUserInAccountGroups" | "AccountPermission_Auth_IsBusinessAccount" | "AccountPermission_Auth_usePlacement" | "AccountPermission_System_Root" | "UserInAccountPermission_AuthAdmin_MinimalRead" | "UserInAccountPermission_AuthAdmin_Modify" | "UserInAccountPermission_AuthAdmin_Read" | "UserInAccountPermission_Auth_Modify" | "UserInAccountPermission_Auth_Read" | "UserInAccountPermission_CachingAdmin_Modify" | "UserInAccountPermission_DiscountAdmin_Modify" | "UserInAccountPermission_DiscountAdmin_Read" | "UserInAccountPermission_Email_Templates" | "UserInAccountPermission_ExternalLicenseAdmin_Modify" | "UserInAccountPermission_ExternalLicenseAdmin_Read" | "UserInAccountPermission_Files_Delete" | "UserInAccountPermission_GenerateCartLinkAdmin_Modify" | "UserInAccountPermission_Instructors_CreateInstructors" | "UserInAccountPermission_Instructors_DeleteInstructors" | "UserInAccountPermission_Instructors_ReadInstructors" | "UserInAccountPermission_Instructors_UpdateInstructors" | "UserInAccountPermission_LearnStates_ReadLearnStates" | "UserInAccountPermission_LearnableAdmin_Modify" | "UserInAccountPermission_LearnableAdmin_Read" | "UserInAccountPermission_LevelDefinitionAdmin_Modify" | "UserInAccountPermission_LevelDefinitionAdmin_Read" | "UserInAccountPermission_LicenseAdmin_Modify" | "UserInAccountPermission_LicenseAdmin_Read" | "UserInAccountPermission_LicenseDefinitionAdmin_Modify" | "UserInAccountPermission_LicenseDefinitionAdmin_Read" | "UserInAccountPermission_LimitedCartDiscountAdmin_Modify" | "UserInAccountPermission_LimitedCartDiscountAdmin_Read" | "UserInAccountPermission_Management_Management" | "UserInAccountPermission_MessageDefinitionAdmin_Modify" | "UserInAccountPermission_MessageDefinitionAdmin_Read" | "UserInAccountPermission_MessageDispatchAdmin_Modify" | "UserInAccountPermission_MessageDispatchAdmin_Read" | "UserInAccountPermission_Nodes_CreateNodes" | "UserInAccountPermission_Nodes_DeleteNodes" | "UserInAccountPermission_Nodes_PublishNodes" | "UserInAccountPermission_Nodes_ReadNodes" | "UserInAccountPermission_Nodes_UpdateNodes" | "UserInAccountPermission_OfferAdmin_Read" | "UserInAccountPermission_OfferAdmin_Write" | "UserInAccountPermission_OrderAdmin_Modify" | "UserInAccountPermission_OrderAdmin_Read" | "UserInAccountPermission_ProductAdmin_Modify" | "UserInAccountPermission_ProductAdmin_Read" | "UserInAccountPermission_ReportAdmin_Modify" | "UserInAccountPermission_ReportAdmin_Read" | "UserInAccountPermission_SettingsAdmin_Modify" | "UserInAccountPermission_SettingsAdmin_Read" | "UserInAccountPermission_Submissions_ReadSubmissions" | "UserInAccountPermission_System_Owner" | "UserInAccountPermission_TagAdmin_Modify" | "UserInAccountPermission_TagAdmin_Read" | "UserInAccountPermission_TagAdmin_Select" | "UserInAccountPermission_Tags_CreateTags" | "UserInAccountPermission_Tags_DeleteTags" | "UserInAccountPermission_Tags_ReadTags" | "UserInAccountPermission_Tags_UpdateTags" | "UserInAccountPermission_TreeStateAdmin_Modify" | "UserInAccountPermission_TreeStateAdmin_Read" | "UserInAccountPermission_TreeUnlockedStateAdmin_Modify" | "UserInAccountPermission_TreeUnlockedStateAdmin_Read" | "UserInAccountPermission_TriggerActionAdmin_Modify" | "UserInAccountPermission_TriggerActionAdmin_Read" | "UserInAccountPermission_UserInAccountAdmin_Modify" | "UserInAccountPermission_UserInAccountAdmin_Read" | "UserInAccountPermission_VimeoVideoSourceAdmin_Modify" | "UserInAccountPermission_VimeoVideoSourceAdmin_Read";
export type selectAccountGroups_Query$variables = {
  id: string;
};
export type selectAccountGroups_Query$data = {
  readonly Admin: {
    readonly UserInAccountGroupManagement: {
      readonly UserInAccountGroupsForAccount: ReadonlyArray<{
        readonly id: string;
        readonly name: string;
        readonly permissions: ReadonlyArray<Permission>;
      }>;
    };
  };
};
export type selectAccountGroups_Query = {
  response: selectAccountGroups_Query$data;
  variables: selectAccountGroups_Query$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "AdminQueryType",
    "kind": "LinkedField",
    "name": "Admin",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "UserInAccountGroupManagementAdminSchema",
        "kind": "LinkedField",
        "name": "UserInAccountGroupManagement",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": [
              {
                "kind": "Variable",
                "name": "accountId",
                "variableName": "id"
              }
            ],
            "concreteType": "UserInAccountGroup",
            "kind": "LinkedField",
            "name": "UserInAccountGroupsForAccount",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "name",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "permissions",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "selectAccountGroups_Query",
    "selections": (v1/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "selectAccountGroups_Query",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "40672efc267fd122af9f2f4278f29af6",
    "id": null,
    "metadata": {},
    "name": "selectAccountGroups_Query",
    "operationKind": "query",
    "text": "query selectAccountGroups_Query(\n  $id: ID!\n) {\n  Admin {\n    UserInAccountGroupManagement {\n      UserInAccountGroupsForAccount(accountId: $id) {\n        id\n        name\n        permissions\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "f901dd92440d1ba34ac71ab4638b3632";

export default node;
